import { createKeyedAsyncQueue } from 'src/modules/shared/utils/async/keyed-queue.util';

/**
 * Serializes transport per destination without retaining completed sends or blocking UI.
 * Rejections release the next explicit submission; no request is retried here.
 * This module owns a stable namespace across rerenders and navigation; other
 * features create their own queue instances even when their keys overlap.
 * @param scope - Account-owned cache, isolating independent app sessions.
 * @param key - Captured conversation/sender/recipient key.
 * @param operation - Starts the next HTTP request after its predecessor settles.
 * @returns This submission's original result or failure.
 */
export const enqueueMessageSend = createKeyedAsyncQueue();
